const loadedResources = new Set();

function loadResource(url: string, type: 'js' | 'css', callback?: Function) {
    if (loadedResources.has(url)) {
        if (callback) {
            callback();
        }
        return;
    }

    let element: any;

    if (type === 'js') {
        element = document.createElement('script');
        element.type = 'text/javascript';
        element.src = url;
    } else if (type === 'css') {
        element = document.createElement('link');
        element.rel = 'stylesheet';
        element.href = url;
    } else {
        throw new Error('Unsupported resource type');
    }

    // 处理加载完成的回调
    element.onload = element.onreadystatechange = function () {
        if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
            element.onload = element.onreadystatechange = null;
            loadedResources.add(url);
            if (callback) {
                callback();
            }
        }
    };

    element.onerror = function () {
        console.error(`Failed to load resource: ${url}`);
    };

    if (type === 'js') {
        document.head.appendChild(element);
    } else if (type === 'css') {
        document.head.appendChild(element);
    }
}

export default loadResource;
